import axios from 'axios'
import { HashMap } from 'common/types'

const apiClient = axios.create({
  // baseURL: 'https://i7klptt6kd2sccabslynt3mam40fhiye.lambda-url.ap-northeast-1.on.aws', // $LATEST
  baseURL: 'https://yzfm3gj7v43pfqwdlncp5zdb3y0pbzlv.lambda-url.ap-northeast-1.on.aws', // prod
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  }
})

export const get = async (url: string, params: HashMap = {}) => {
  return apiClient
    .get(url, {
      params
    })
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.error(err)
      return null
    })
}

export const post = async (url: string, params: HashMap = {}) => {
  return apiClient
    .post(url, params)
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.error(err)
      return null
    })
}
